/**
 * Suppress noisy console errors/warnings from third-party SDKs that are
 * cosmetic and not actionable:
 *
 * - MetaKeep: "Error refreshing id token" (stale session before fresh login)
 * - WalletConnect: SVG viewBox "0 0 100% 40" (invalid SVG in their modal UI)
 * - SES/Lockdown: "Removing unpermitted intrinsics" (wallet extension sandbox)
 * - Web3Auth: "sapphire_devnet" warning (expected in dev)
 */

const SUPPRESSED_PATTERNS = [
  "refreshing id token",
  "SES Removing unpermitted intrinsics",
  'attribute viewBox: Expected number, "0 0 100%',
  "sapphire_devnet",
  "Lit is in dev mode",
  "Failed to fetch project configurations TypeError: Failed to fetch",
];

function shouldSuppress(args) {
  try {
    const msg = args
      .map((a) => {
        if (typeof a === "string") return a;
        try { return String(a ?? ""); } catch { return ""; }
      })
      .join(" ");
    return SUPPRESSED_PATTERNS.some((p) => msg.includes(p));
  } catch {
    return false;
  }
}

const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args) => {
  if (!shouldSuppress(args)) originalError.apply(console, args);
};

console.warn = (...args) => {
  if (!shouldSuppress(args)) originalWarn.apply(console, args);
};

export default () => {};
